<template>
  <div class="games">
    <div id="head-page" class="globulo parallaxe">
      <div id="scene">
      </div>
    </div>

    <div class="grid-container content-page"> 
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-6 medium-offset-3 cell center">
          <title-page class="number" attrpage="404" baseline="C'est une impasse, cette page n'existe pas">Mauvais chemin !</title-page>
          
          <div class="road-game gabarit">
            <div class="box-mascotte">
              <img src="@/assets/images/mascotte/mascotte-red.png" alt="Globulo Quest mascotte" title="Globulo Quest mascotte"/>
              <div class="bubble left txtleft">J'ai l'impression que la page que tu cherches n'est pas ici...</br>Tu pourras surement retrouver ton chemin en suivant <a href="/" title="" >ce lien.</a></div>
            </div> 
          </div>
          
        </div> 
      </div> 
    </div>    
  </div>    
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import GameItem from '@/components/GameItem'
  export default {
    components: { TitlePage, GameItem }
  }
</script>
